import React from 'react';
import { login, loginWithGoogle } from '../services/auth';

function Login() {
  return (
    <div className="row justify-content-center">
      <div className="col-md-5">
        <div className="card mt-5">
          <div className="card-body text-center">
            <h2 className="card-title mb-4">Sign in</h2>
            <p className="text-muted">Sign in to post and manage your listings.</p>

            <button
              className="btn btn-primary w-100 mb-3"
              onClick={() => login()}
            >
              Sign in / Sign up with email
            </button>

            <button
              className="btn btn-outline-dark w-100"
              onClick={() => loginWithGoogle()}
            >
              Continue with Google
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
